// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2): MenuPanel shell + MenuPanelItem rows for the two command lists. The
// QuickAddPanel block embeds a form (selects + FileSidebarAddNewItem), so it
// keeps its own structure — only the shell and the item rows re-chassis.
// Deleted with the re-chassis: the `margin: '- -Z2'` list pulls (they
// compensated the old hand-rolled `padding: 'A A1'` body; MenuPanel pads Y
// and MenuPanelItem rows run full-width, so a -Z2 pull would overflow the
// panel by Z2 − Y and clip), the `':hover': { '& svg': … }` opacity armor
// (fought the retired KeyValueColumnFields/DropdownItem svg games), and the
// three `Line` dividers — sparse command groups with captions, so the body
// gap separates them (§7.7 default: gap, not hairlines).
const Dropdownquickadd = {
  extends: 'MenuPanel',
  state: {},
  width: 'G+C',
  gap: 'A',
  textAlign: 'start',
  QuickAddMenu: {
    CaptionTitle: {
      margin: '- - Z',
      // Align the caption with MenuPanelItem's Z1 label inset.
      padding: '- Z1',
      Text: {
        text: '{{ editor.quickAdd.addBlank | polyglot }}'
      }
    },
    Items: {
      flow: 'y',
      gap: '0',
      childExtends: 'MenuPanelItem',
      childProps: {
        gap: 'X',
        Icon: {
          order: '-1',
          margin: '0'
        }
      },
      childrenAs: 'props',
      children: (el) => [
        {
          text: '{{ editor.quickAdd.component | polyglot }}',
          Icon: {
            name: 'plus'
          },
          onClick: (ev, el, s) => {
            const key = el.call('findNewName', 'components', 'NewComponent', {
              autoRename: true
            })
            el.call('createItem', 'components', key)
          }
        },
        {
          text: '{{ editor.quickAdd.page | polyglot }}',
          Icon: {
            name: 'plus'
          },
          onClick: (ev, el, s) => {
            const key = el.call('findNewName', 'pages', '/new-page', {
              autoRename: true
            })
            el.call('createItem', 'pages', key)
          }
        },
        {
          text: '{{ editor.quickAdd.file | polyglot }}',
          Icon: {
            name: 'plus'
          },
          onClick: (ev, el, s) => {
            el.call('openRouterModal', '/add-file')
          }
        }
      ]
    }
  },
  // MoreInsertMenu re-chassised onto MenuPanelItem rows in the bespoke-menus
  // wave — the -Z2 pull (and this site's neutralization of it) is gone.
  MoreInsertMenu: {},
  QuickAddPanel: {
    CaptionTitle: {
      margin: '- - Y2',
      padding: '- Z1',
      Text: {
        text: '{{ editor.quickAdd.applyAction | polyglot }}'
      }
    },
    Flex: {
      flow: 'y',
      gap: 'Z2',
      childProps: {
        width: '100%'
      },
      Select_action: {
        width: '100%'
      },
      Select_type: {
        width: '100%'
      },
      FileSidebarAddNewItem: {
        order: 2,
        margin: '-X W -',
        Label: {
          Flex: {
            margin: '- -W - -',
            order: 2,
            opacity: 1,
            Save: {
              extends: 'NavbarButton'
            },
            Close: null
          }
        }
      }
    }
  },
  ComingSoonMenu: {
    CaptionTitle_soon: {
      padding: '- Z1',
      Text: {
        text: '{{ common.state.coming_soon | polyglot }}'
      }
    },
    Items: {
      flow: 'y',
      gap: '0',
      childExtends: 'MenuPanelItem',
      childProps: {
        Icon: {
          order: '-1',
          margin: '- Y1 - -'
        }
      },
      childrenAs: 'props',
      children: (el) => [
        {
          text: '{{ shell.app.marketplace | polyglot }}',
          Icon: {
            name: 'plus'
          },
          onClick: (ev, el) => {
            el.setWindow('explorer', 'insert')
          }
        },
        {
          text: '{{ editor.panel.integrations | polyglot }}',
          Icon: {
            name: 'fuse'
          },
          onClick: (ev, el) => {
            el.setWindow('explorer', 'insert:integrations')
          }
        },
        {
          text: 'Figma',
          Icon: {
            name: 'figma'
          },
          Sup: {
            margin: '-Z - - X2',
            fontSize: 'Y',
            text: '{{ editor.logoMenu.soon | polyglot }}'
          },
          onClick: (ev, el) => {
            el.setWindow('explorer', 'insert:figma')
          }
        },
        {
          text: '{{ editor.panel.icons | polyglot }}',
          Icon: {
            name: 'icons'
          },
          Sup: {
            margin: '-Z - - X2',
            fontSize: 'Y',
            text: '{{ editor.logoMenu.soon | polyglot }}'
          },
          onClick: (ev, el) => {
            el.setWindow('explorer', 'insert:icons')
          }
        },
        {
          text: '{{ editor.panel.fonts | polyglot }}',
          Icon: {
            name: 'fontFace'
          },
          Sup: {
            margin: '-Z - - X2',
            fontSize: 'Y',
            text: '{{ editor.logoMenu.soon | polyglot }}'
          },
          onClick: (ev, el) => {
            el.setWindow('explorer', 'insert:fonts')
          }
        }
      ]
    }
  }
}

export { Dropdownquickadd as 'Dropdown.QuickAdd' }
